import { useLabels, useProjectDataStore } from 'src/StoreDataProvider';
import AccordionOutcomeImpact from '../AccordionOutcomeImpact';
import { PanelProps } from './panel.types';

const Panel: (props: PanelProps) => JSX.Element = () => {
  const {
    projectDetails: { outcome, impacts },
  } = useProjectDataStore();
  const labels = useLabels();

  return (
    <>
      <AccordionOutcomeImpact
        title={labels.outcomeTitle}
        isActive={true}
        indicators={outcome.indicators}
        targets={outcome.targets}
      />
      <hr aria-hidden="true" className="detail-component"></hr>
      <AccordionOutcomeImpact
        title={labels.impactTitle}
        isActive={true}
        indicators={impacts.indicators}
        targets={impacts.targets}
      />
    </>
  );
};
export default Panel;
